window.KK_FIT = {"standards":{"doorHeader":80,"eye":57,"widthMin":0.66,"widthMax":0.85},"objects":{"stool":{"asset":"kk-fit-stool.png","label":"cane-topped stool","w":24,"h":22.9,"back":23.4,"seen":"seated / from the bed"},"bedside":{"asset":"kk-fit-bedside.png","label":"bedside table","w":24,"h":20.8,"back":24,"seen":"seated / from the bed"},"brass-table":{"asset":"kk-fit-brass-table.png","label":"brass-topped table","w":32,"h":26.1,"back":32,"seen":"seated / from the bed"},"chest":{"asset":"kk-fit-chest.png","label":"carved chest","w":40,"h":23.6,"back":40,"seen":"standing, in passing"},"teak-console":{"asset":"kk-fit-teak-console.png","label":"teak console","w":48,"h":31,"back":48,"seen":"standing, in passing"},"carved-console":{"asset":"kk-fit-carved-console.png","label":"carved console table","w":48,"h":35.2,"back":48,"seen":"standing, in passing"},"carved-diwan":{"asset":"kk-fit-carved-diwan.png","label":"carved wooden diwan","w":72,"h":31.6,"back":50.9,"seen":"standing and seated opposite"},"cane-diwan":{"asset":"kk-fit-cane-diwan.png","label":"teak cane diwan","w":72,"h":35,"back":59.5,"seen":"standing and seated opposite"},"bench":{"asset":"kk-fit-bench.png","label":"carved wooden bench","w":48,"h":31.2,"back":42.1,"seen":"standing, in passing"},"sofa72":{"asset":"kk-fit-sofa72.png","label":"3-seat sofa","w":72,"h":30.5,"back":57.7,"seen":"standing and seated opposite"},"sandook":{"asset":"kk-fit-sandook.png","label":"wooden sandook chest","w":48,"h":22.8,"back":48,"seen":"standing, in passing"},"low-diwan":{"asset":"kk-fit-low-diwan.png","label":"low wooden diwan","w":66,"h":26,"back":54.4,"seen":"standing and seated opposite"},"side-cabinet":{"asset":"kk-fit-side-cabinet.png","label":"carved side cabinet","w":32,"h":22.5,"back":32,"seen":"seated / from the bed"},"manji":{"asset":"kk-fit-manji.png","label":"woven manji bench","w":40,"h":18.7,"back":36.3,"seen":"standing, in passing"}},"sizes":{"18x18":{"w":18,"h":18,"cm":[46,46],"obj":"stool","gap":8.1,"centre":40,"top":49,"pct":77},"20x20":{"w":20,"h":20,"cm":[51,51],"obj":"bedside","gap":9.2,"centre":40,"top":50,"pct":83},"24x24":{"w":24,"h":24,"cm":[61,61],"obj":"brass-table","gap":6,"centre":44.1,"top":56.1,"pct":75},"30x30":{"w":30,"h":30,"cm":[76,76],"obj":"chest","gap":8,"centre":46.6,"top":61.6,"pct":75},"32x32":{"w":32,"h":32,"cm":[81,81],"obj":"chest","gap":8,"centre":47.6,"top":63.6,"pct":80},"36x36":{"w":36,"h":36,"cm":[91,91],"obj":"teak-console","gap":8,"centre":57,"top":75,"pct":75},"36x18":{"w":36,"h":18,"cm":[91,46],"obj":"carved-console","gap":8,"centre":52.2,"top":61.2,"pct":75},"40x20":{"w":40,"h":20,"cm":[102,51],"obj":"carved-diwan","gap":8.4,"centre":50,"top":60,"pct":79},"48x24":{"w":48,"h":24,"cm":[122,61],"obj":"cane-diwan","gap":8,"centre":55,"top":67,"pct":81},"30x20":{"w":30,"h":20,"cm":[76,51],"obj":"bench","gap":8,"centre":49.2,"top":59.2,"pct":71},"36x24":{"w":36,"h":24,"cm":[91,61],"obj":"teak-console","gap":8,"centre":51,"top":63,"pct":75},"48x32":{"w":48,"h":32,"cm":[122,81],"obj":"sofa72","gap":8,"centre":54.5,"top":70.5,"pct":83},"20x30":{"w":20,"h":30,"cm":[51,76],"obj":"bedside","gap":6,"centre":41.8,"top":56.8,"pct":83},"24x36":{"w":24,"h":36,"cm":[61,91],"obj":"brass-table","gap":6,"centre":50.1,"top":68.1,"pct":75},"32x48":{"w":32,"h":48,"cm":[81,122],"obj":"sandook","gap":8,"centre":54.8,"top":78.8,"pct":67},"24x18":{"w":24,"h":18,"cm":[61,46],"obj":"brass-table","gap":6,"centre":41.1,"top":50.1,"pct":75},"32x24":{"w":32,"h":24,"cm":[81,61],"obj":"bench","gap":8,"centre":51.2,"top":63.2,"pct":76},"40x30":{"w":40,"h":30,"cm":[102,76],"obj":"low-diwan","gap":9,"centre":50,"top":65,"pct":74},"48x36":{"w":48,"h":36,"cm":[122,91],"obj":"sofa72","gap":8,"centre":56.5,"top":74.5,"pct":83},"18x24":{"w":18,"h":24,"cm":[46,61],"obj":"stool","gap":6,"centre":40.9,"top":52.9,"pct":77},"24x32":{"w":24,"h":32,"cm":[61,81],"obj":"side-cabinet","gap":6,"centre":44.5,"top":60.5,"pct":75},"30x40":{"w":30,"h":40,"cm":[76,102],"obj":"manji","gap":8,"centre":46.7,"top":66.7,"pct":83},"36x48":{"w":36,"h":48,"cm":[91,122],"obj":"sandook","gap":8,"centre":54.8,"top":78.8,"pct":75}}};

(function () {
  "use strict";
  if (window.__KK_SC) return;
  window.__KK_SC = 1;

  function tok(name, fb) {
    try {
      var root = getComputedStyle(document.documentElement);
      if (!root.getPropertyValue(name).trim()) return fb;
      var p = document.createElement("span");
      p.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;color:var(" + name + ")";
      (document.body || document.documentElement).appendChild(p);
      var c = getComputedStyle(p).color;
      p.parentNode.removeChild(p);
      return c || fb;
    } catch (e) { return fb; }
  }
  var INK = tok("--sumi", "#1F241C"), MUTE = tok("--muted", "#6B6A66"), ACCENT = tok("--chrome", "#8B4434"), RULE = tok("--sc-rule", "#b9b1a2");
  var WALL = tok("--sc-wall", "#EDE4D3"), FLOOR = tok("--sc-floor", "#DCD1BC"), SHEET = tok("--sc-sheet", "#E7DFD0"), FIG = tok("--sc-figure", "#cdc6b8"), DARK = INK;
  var MAX_H = 460;   // px. A band of evidence under the buy decision, not a page of its own.
  var MIN_PX = 3.7;  // px per inch below which the size printed on the canvas stops being readable

  function f(n) { return Math.round(n * 100) / 100; }
  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }
  var IN = "&#8243;", X = "&#215;";

  var FIG_H = 72, FIG_W = 72 * 0.3;
  function figure(x, floorY) {
    var k = FIG_H / 1000;
    return '<g transform="translate(' + f(x) + ',' + f(floorY - FIG_H) + ') scale(' + f(k) + ')" fill="' + FIG + '">' +
      '<ellipse cx="150" cy="62" rx="46" ry="62"/><rect x="136" y="112" width="28" height="34" rx="12"/>' +
      '<ellipse cx="150" cy="176" rx="111" ry="34"/><path d="M 62,150 L 238,150 L 220,520 L 80,520 Z"/>' +
      '<rect x="39" y="152" width="36" height="382" rx="18"/><rect x="225" y="152" width="36" height="382" rx="18"/>' +
      '<rect x="80" y="498" width="140" height="70" rx="24"/>' +
      '<rect x="92" y="540" width="54" height="452" rx="24"/><rect x="154" y="540" width="54" height="452" rx="24"/>' +
      '<rect x="86" y="972" width="66" height="28" rx="8"/><rect x="148" y="972" width="66" height="28" rx="8"/></g>';
  }

  function rect(x, y, w, h, fill) {
    return '<rect x="' + f(x) + '" y="' + f(y) + '" width="' + f(w) + '" height="' + f(h) +
           '" fill="' + fill + '"/>';
  }

  var MOUNT = { floater: { face: 10 / 25.4, reveal: 8 / 25.4 },
                classic: { face: 15 / 25.4, overlap: 5 / 25.4 } };
  function frame(x, y, w, h, mount) {
    if (mount === "classic") {
      var out = MOUNT.classic.face - MOUNT.classic.overlap, ov = MOUNT.classic.overlap;
      return rect(x - out, y - out, w + out * 2, h + out * 2, INK) +
             rect(x + ov, y + ov, w - ov * 2, h - ov * 2, SHEET);
    }
    var band = MOUNT.floater.face + MOUNT.floater.reveal, rv = MOUNT.floater.reveal;
    return rect(x - band, y - band, w + band * 2, h + band * 2, INK) +
           rect(x - rv, y - rv, w + rv * 2, h + rv * 2, DARK) +
           rect(x, y, w, h, SHEET);
  }

  function sizeOnCanvas(cx, cy, d, scale) {
    var big = Math.min(d.w, d.h) * 0.21;
    if (big * scale > 30) big = 30 / scale;
    var sm = big * 0.40;
    if (sm * scale < 7) sm = 0;
    function t(y, str, size, fill) {
      return '<text x="' + f(cx) + '" y="' + f(y) + '" font-size="' + f(size) + '" fill="' + fill +
             '" text-anchor="middle" font-family="Georgia,serif">' + str + "</text>";
    }
    var s = t(cy + big * 0.18, d.w + " " + X + " " + d.h, big, INK);
    if (sm) {
      s += t(cy + big * 0.18 + sm * 1.6, "inches", sm, MUTE);
      s += t(cy + big * 0.18 + sm * 2.9, d.cm[0] + " " + X + " " + d.cm[1] + " cm", sm * 0.92, MUTE);
    }
    return s;
  }

  function highlight(x, y, w, h, scale) {
    var o = 4 / scale;
    return '<rect x="' + f(x - o) + '" y="' + f(y - o) + '" width="' + f(w + o * 2) + '" height="' +
      f(h + o * 2) + '" fill="none" stroke="' + ACCENT + '" stroke-width="' + f(1.4 / scale) + '"/>';
  }

  function layoutPerson(list) {
    var PAD = 5, cols = [], x = FIG_W + PAD, i;
    for (i = 0; i < list.length; i++) {
      cols.push({ d: list[i], x: x, w: list[i].w });
      x += list[i].w + PAD;
    }
    return { W: x - PAD, H: FIG_H + 1, floorY: FIG_H, cols: cols, mode: "person" };
  }
  var GUT = 26;
  function layoutRoom(list, std, objects) {
    var PAD = 9, cols = [], x = GUT, i;
    for (i = 0; i < list.length; i++) {
      var o = objects[list[i].obj];
      cols.push({ d: list[i], o: o, x: x, w: Math.max(list[i].w + 2, o.w) });
      x += cols[i].w + PAD;
    }
    var floorY = std.doorHeader + 5;
    return { W: x - PAD, H: floorY + 1.4, floorY: floorY, cols: cols, mode: "room", std: std };
  }

  function paint(g, mount, selected, scale, W) {
    var s = "", i, c, cx, off = (W - g.W) / 2, floorY = g.floorY;

    if (g.mode === "room") {
      s += rect(off, 0, g.W, floorY, WALL);
      s += rect(off, floorY, g.W, 1.4, FLOOR);
      [[g.std.doorHeader, "DOOR HEADER"], [g.std.eye, "EYE LEVEL"]].forEach(function (r) {
        var y = floorY - r[0];
        s += '<line x1="' + f(off + GUT - 3) + '" y1="' + f(y) + '" x2="' + f(off + g.W) + '" y2="' + f(y) +
             '" stroke="' + RULE + '" stroke-width="' + f(1 / scale) + '" stroke-dasharray="' +
             f(5 / scale) + " " + f(4 / scale) + '"/>';
        s += '<text x="' + f(off + GUT - 6) + '" y="' + f(y - 4 / scale) + '" font-size="' + f(10 / scale) +
             '" fill="' + MUTE + '" text-anchor="end" font-family="Helvetica,Arial,sans-serif"' +
             ' font-weight="600" letter-spacing="' + f(1 / scale) + '">' + r[1] + "</text>";
        s += '<text x="' + f(off + GUT - 6) + '" y="' + f(y + 9 / scale) + '" font-size="' + f(10 / scale) +
             '" fill="' + RULE + '" text-anchor="end" font-family="Helvetica,Arial,sans-serif"' +
             ' font-weight="600">' + r[0] + IN + "</text>";
      });
    } else {
      s += figure(off, floorY);
      s += '<line x1="' + f(off) + '" y1="' + f(floorY) + '" x2="' + f(off + g.W) + '" y2="' +
           f(floorY) + '" stroke="' + INK + '" stroke-width="' + f(1.2 / scale) + '"/>';
      s += '<text x="' + f(off + FIG_W / 2) + '" y="' + f(floorY - 2.5 / scale) + '" font-size="' +
           f(10.5 / scale) + '" fill="' + MUTE + '" text-anchor="middle" font-weight="600"' +
           ' font-family="Helvetica,Arial,sans-serif">6 FT</text>';
    }

    for (i = 0; i < g.cols.length; i++) {
      c = g.cols[i];
      cx = off + c.x + c.w / 2;
      var d = c.d;
      var top = g.mode === "room" ? floorY - d.top : floorY - d.h;
      if (g.mode === "room") {
        s += '<image href="' + c.o.src + '" x="' + f(cx - c.o.w / 2) + '" y="' + f(floorY - c.o.h) +
             '" width="' + f(c.o.w) + '" height="' + f(c.o.h) + '" preserveAspectRatio="none"/>';
        s += '<line x1="' + f(cx) + '" y1="' + f(top + d.h) + '" x2="' + f(cx) + '" y2="' +
             f(top + d.h + d.gap) + '" stroke="' + ACCENT + '" stroke-width="' + f(1 / scale) + '"/>';
        s += '<text x="' + f(cx + 2) + '" y="' + f(top + d.h + d.gap / 2 + 3.5 / scale) +
             '" font-size="' + f(10.5 / scale) + '" fill="' + ACCENT + '" font-weight="600"' +
             ' font-family="Georgia,serif">' + Math.round(d.gap) + IN + " gap</text>";
      }
      s += frame(cx - d.w / 2, top, d.w, d.h, mount);
      s += sizeOnCanvas(cx, top + d.h / 2, d, scale);
      if (d.size === selected) s += highlight(cx - d.w / 2, top, d.w, d.h, scale);
      c.pct = (cx - off) / g.W * 100;
      c.wpct = c.w / g.W * 100;
    }
    return s;
  }

  function captions(g, selected) {
    var h = "";
    for (var i = 0; i < g.cols.length; i++) {
      var c = g.cols[i], d = c.d, on = d.size === selected;
      h += '<div class="sc-cap' + (on ? " is-on" : "") + '" style="left:' + f(c.pct) +
           "%;width:" + f(Math.max(c.wpct, 16)) + '%">';
      h += '<span class="sc-cap-size">' + d.w + IN + " " + X + " " + d.h + IN + "</span>";
      h += '<span class="sc-cap-cm">' + d.cm[0] + " " + X + " " + d.cm[1] + " cm</span>";
      if (g.mode === "room") {
        h += '<span class="sc-cap-obj">' + esc(c.o.label) + "</span>";
        h += '<span class="sc-cap-pct"><b>' + d.pct + "%</b> of its " + Math.round(c.o.back) + IN + " back</span>";
        h += '<span class="sc-cap-cm">centre ' + Math.round(d.centre) + IN + " up</span>";
      } else if (on) {
        h += '<span class="sc-cap-pct"><b>Your size</b></span>';
      }
      h += "</div>";
    }
    return h;
  }

  var merged = false;
  function render(root) {
    var M = window.KK_FIT;
    if (!M) return;
    if (!merged) {
      var SRC = window.KK_FIT_SRC || {};
      for (var k in M.objects) if (SRC[k]) M.objects[k].src = SRC[k];
      merged = true;
    }
    var names = (root.getAttribute("data-sizes") || "").split(",")
      .map(function (x) { return x.trim(); }).filter(Boolean);
    var list = [], i, p;
    for (i = 0; i < names.length; i++) {
      var d = M.sizes[names[i]];
      if (!d) { if (window.console) console.warn("[size-compare] no fit data for " + names[i]); continue; }
      var row = { size: names[i] };
      for (p in d) row[p] = d[p];
      list.push(row);
    }
    if (!list.length) { root.setAttribute("hidden", "hidden"); return; }
    list.sort(function (a, b) { return a.w * a.h - b.w * b.h; });

    var mount = root.getAttribute("data-mount") || "floater";
    var selected = root.getAttribute("data-selected") || "";
    var mode = root.getAttribute("data-mode") || "room";
    var stage = root.querySelector("[data-sc-stage]");
    if (!stage) return;

    var gp = layoutPerson(list), gr = layoutRoom(list, M.standards, M.objects);
    var W = Math.max(gp.W, gr.W);
    var g = mode === "person" ? gp : gr;

    var avail = stage.clientWidth || root.clientWidth || 900;
    var scale = Math.min(avail / W, MAX_H / g.H);
    if (scale < MIN_PX) scale = MIN_PX;                 // below this it scrolls rather than shrinks
    var wpx = Math.round(W * scale), hpx = Math.round(g.H * scale);

    var svg = '<svg viewBox="0 0 ' + f(W) + " " + f(g.H) + '" width="' + wpx + '" height="' + hpx +
      '" role="img" aria-label="' + esc(list.map(function (r) {
        return r.w + " by " + r.h + " inches"; }).join(", ")) + '">' +
      paint(g, mount, selected, scale, W) + "</svg>";

    stage.innerHTML = '<div class="sc-canvas" style="width:' + wpx + 'px">' + svg +
      '<div class="sc-caps">' + captions(g, selected) + "</div></div>";
    root.classList.toggle("sc-scrolls", wpx > avail + 2);
  }

  function normalise(v) {
    return String(v || "").toLowerCase().replace(/\s*[x×]\s*/, "x").replace(/["″′]|in|\./g, "").trim();
  }
  function pick(root, value) {
    var v = normalise(value);
    if (!window.KK_FIT || !window.KK_FIT.sizes[v]) return;
    if (root.getAttribute("data-selected") === v) return;
    root.setAttribute("data-selected", v);
    render(root);
  }

  function enhancePicker(root) {
    var M = window.KK_FIT;
    if (!M) return;
    var btns = document.querySelectorAll("[data-option-value]");
    var rows = [], any = false;
    Array.prototype.forEach.call(btns, function (b) {
      var d = M.sizes[normalise(b.getAttribute("data-option-value"))];
      if (!d || b.querySelector(".sc-tip")) return;
      var o = M.objects[d.obj];
      var tip = document.createElement("span");
      tip.className = "sc-tip";
      tip.innerHTML = "<b>" + d.cm[0] + " " + X + " " + d.cm[1] + " cm</b>" +
        "<i>" + d.pct + "% of a " + Math.round(o.back) + IN + " " + esc(o.label) + "</i>" +
        "<i>centre " + Math.round(d.centre) + IN + " from the floor</i>";
      b.appendChild(tip);
      b.classList.add("has-sc-tip");
      any = true;
      var row = b.parentNode;
      if (rows.indexOf(row) === -1) rows.push(row);
    });
    if (!any) return;
    rows.forEach(function (row) {
      if (row.parentNode.querySelector(".sc-jump")) return;
      var n = row.querySelectorAll(".has-sc-tip").length;
      var a = document.createElement("a");
      a.className = "sc-jump";
      a.href = "#find-your-fit";
      a.innerHTML = "Not sure? See " + (n > 1 ? "all " + n + " sizes" : "this size") +
        " to scale <b>&darr;</b>";
      a.addEventListener("click", function (e) {
        e.preventDefault();
        root.scrollIntoView({ behavior: "smooth", block: "start" });
        history.replaceState(null, "", "#find-your-fit");
      });
      row.parentNode.insertBefore(a, row.nextSibling);
    });
  }

  function wire(root) {
    var tabs = root.querySelectorAll("[data-sc-tab]");
    Array.prototype.forEach.call(tabs, function (btn) {
      btn.addEventListener("click", function () {
        root.setAttribute("data-mode", btn.getAttribute("data-sc-tab"));
        Array.prototype.forEach.call(tabs, function (b) {
          b.classList.toggle("is-on", b === btn);
          b.setAttribute("aria-selected", b === btn ? "true" : "false");
        });
        render(root);
      });
    });
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.name || t.name.toLowerCase().indexOf("size") === -1) return;
      pick(root, t.value);
    });
    document.addEventListener("click", function (e) {
      var b = e.target && e.target.closest && e.target.closest("[data-option-value]");
      if (b) pick(root, b.getAttribute("data-option-value"));
    });
    var t;
    window.addEventListener("resize", function () {
      clearTimeout(t); t = setTimeout(function () { render(root); }, 160);
    });
    render(root);
    enhancePicker(root);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-size-compare]"), wire);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
